import { EventBus } from "OK/EventBus";

export const ToolbarDropdownEventBusesPrefix = 'ui.toolbar-dropdown';

const create = EventBus.factory(ToolbarDropdownEventBusesPrefix);

export const TOOLBAR_DROPDOWN_OPEN = create<void>('open');
export const TOOLBAR_DROPDOWN_OPENED = create<void>('opened');
